import { Box } from '@mui/material';
import { Outlet, useRouter } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { useCurrentUserQuery, UserState } from 'entities/user';
import { Routes } from 'shared/routes';
import Loader from 'shared/ui/Loader';
import { ClientFooter } from 'widgets/client-footer';
import { AccountExpiryWeekWarningBanner, ClientHeader } from 'widgets/client-header';

import { styles } from './styles';

const ClientLayout = () => {
  const { data: currentUser, isLoading } = useCurrentUserQuery();
  const router = useRouter();

  if (isLoading) {
    return <Loader />;
  }

  if (!currentUser) {
    router.navigate({ to: Routes.frontend.loginPath });
    return null;
  }

  if (currentUser.state === UserState.Created) {
    router.navigate({ to: Routes.frontend.registrationPath });
    return null;
  }

  return (
    <Box sx={styles.root}>
      {/* Background decorative ellipse */}
      <Box sx={styles.backgroundEllipse} />

      {/* Main content */}
      <Box sx={styles.content}>
        <ClientHeader />
        <AccountExpiryWeekWarningBanner />
        <Box component="main" sx={styles.main}>
          <Outlet />
          <TanStackRouterDevtools />
        </Box>
        <ClientFooter />
      </Box>
    </Box>
  );
};

export { ClientLayout };
